import {helpers, required} from '@vuelidate/validators';

export default {
  methods: {
    requiredWithCustomMessage(message) {
      const wrapped = helpers.withParams({$hasCustomMessage: true}, helpers.withMessage(message, required));
      return wrapped;
    },
    isCustomMessage(error) {
      return error.$params.$hasCustomMessage;
    },
  },
};
